const TongaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112574)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.0431 10.4358V7.82715H10.4344V10.4358H7.82568V13.0446H10.4344V15.6532H13.0431V13.0446H15.6518V10.4358H13.0431Z"
        fill="#D80027"
      />
      <path
        d="M20 0V20C8.95437 20.0001 4.56445 20 0 20.0001C0 31.0456 8.95437 40 20 40C31.0456 40 40 31.0456 40 20C40 8.95437 31.0456 0 20 0Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112574">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TongaSvg;
